<template>
  <div style="padding-top: 50px;" :style="{height:mHeight}">
    <el-col :span="2"><div class="grid-content"></div></el-col>
    <el-col :span="20" style="background-color: #ffffff">
      <div style="height: 40px;margin-bottom: -25px;">
        <el-image fit="scale-down" style="width: 20%;margin-left: 2.5%;margin-right: 2.5%;height: 100%;display: inline-block"  src="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-124.png"></el-image>
        <el-image fit="scale-down"  style="width: 20%;margin-left: 2.5%;margin-right: 2.5%;height: 100%;display: inline-block"  src="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-125.png"></el-image>
        <el-image fit="scale-down"  style="width: 20%;margin-left: 2.5%;margin-right: 2.5%;height: 100%;display: inline-block"  src="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-126.png"></el-image>
        <el-image fit="scale-down"  style="width: 20%;margin-left: 2.5%;margin-right: 2.5%;height: 100%;display: inline-block;"  src="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-164.png"></el-image>
      </div>
      <el-tabs class="selfdiv" :stretch="true" v-model="activeName" @tab-click="handleClick" style="margin-top: 0px;" :style="{fontSize:minFontSize}">
        <el-tab-pane label="生物科技" name="first">
          <div style="display: none">1</div>
        </el-tab-pane>
        <el-tab-pane label="生产制造" name="second">
          <div style="display: none">2</div>
        </el-tab-pane>
        <el-tab-pane label="旅游服务" name="third">
          <div style="display: none">3</div>
        </el-tab-pane>
        <el-tab-pane label="物业地产" name="fourth">
          <div style="display: none">4</div>
        </el-tab-pane>
      </el-tabs>

      <div style="width: 100%;" :style="{height:height1}">
        <div style="width: 100%;height: 10.27%;"></div>
        <el-image fit="scale-down" :src="titlePic" style="height: 19.72%"></el-image>
        <div style="width: 100%;height: 7.222%;"></div>
        <div style="width: 80%;margin-left: 10%;" :style="{height:contentH}">
          <div style="width: 100%;height: 100%;" v-show="showIndex==0">
            <el-image fit="fill" style="width:47.741%;height: 100%;float:left;" src="http://zgpic.xingfujijiu.cn/tech1.png"></el-image>
            <div style="width: 4.518%;height: 100%;float:left;"></div>
            <el-image fit="fill"  style="width:47.741%;height: 100%;float:left;" src="http://zgpic.xingfujijiu.cn/tech2.png"></el-image>
          </div>
          <div style="width: 100%;height: 100%;" v-show="showIndex==1">
            <el-image fit="fill" style="width:47.741%;height: 100%;" src="http://zgpic.xingfujijiu.cn/product.png"></el-image>
          </div>
          <div style="width: 100%;height: 100%;" v-show="showIndex==2">
            <el-image fit="fill" style="width:31.4333333%;height: 100%;float:left;" src="http://zgpic.xingfujijiu.cn/lvyou1.png"></el-image>
            <div style="width: 2.85%;height: 100%;float:left;"></div>
            <el-image fit="fill"  style="width:31.4333333%;height: 100%;float:left;" src="http://zgpic.xingfujijiu.cn/lvyou2.png"></el-image>
            <div style="width: 2.85%;height: 100%;float:left;"></div>
            <el-image fit="fill"  style="width:31.4333333%;height: 100%;float:left;" src="http://zgpic.xingfujijiu.cn/lvyou3.png"></el-image>
          </div>
          <div style="width: 100%;height: 100%;" v-show="showIndex==3">
            <el-image fit="fill" style="width:31.4333333%;height: 100%;float:left;" src="http://zgpic.xingfujijiu.cn/touzi1.png"></el-image>
            <div style="width: 2.85%;height: 100%;float:left;"></div>
            <el-image fit="fill"  style="width:31.4333333%;height: 100%;float:left;" src="http://zgpic.xingfujijiu.cn/touzi2.png"></el-image>
            <div style="width: 2.85%;height: 100%;float:left;;"></div>
            <el-image fit="fill"  style="width:31.4333333%;height: 100%;float:left;" src="http://zgpic.xingfujijiu.cn/touzi3.png"></el-image>
          </div>
        </div>
      </div>

    </el-col>
    <el-col :span="2">
      <div class="grid-content"></div>
    </el-col>
  </div>
</template>
<script>
import PubSub from "pubsub-js";

export default {
  name: "jituanbuju",
  methods:{
    handleClick(tab) {
      this.changeIndex=tab._data.index;
      switch (tab._data.index){
        case '0':
          PubSub.publish('changeIndex', {"name":"jituanbuju","query":{"step":"first"}});
          this.$router.push({query:{'step':'first'}});
          this.titlePic="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-165.png";
          this.showIndex=0;
          break;
        case '1':
          PubSub.publish('changeIndex', {"name":"jituanbuju","query":{"step":"second"}});
          this.$router.push({query:{'step':'second'}});
          this.titlePic="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-166.png";
          this.showIndex=1;
          break;
        case '2':
          PubSub.publish('changeIndex', {"name":"jituanbuju","query":{"step":"third"}});
          this.$router.push({query:{'step':'third'}});
          this.titlePic="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-167.png";
          this.showIndex=2;
          break;
        case '3':
          PubSub.publish('changeIndex', {"name":"jituanbuju","query":{"step":"fourth"}});
          this.$router.push({query:{'step':'fourth'}});
          this.titlePic="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-168.png";
          this.showIndex=3;
          break;
      }
    }
  },
  data(){
    return {
      activeName: 'first',
      mHeight:document.body.clientWidth*800/1920+30+'px',
      changeIndex:'0',
      minFontSize:(document.body.clientWidth<850?850:document.body.clientWidth)/85+"px",
      height1:document.body.clientWidth*700/1920+'px',
      titlePic:"http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-165.png",
      showIndex:0,
      contentH:document.body.clientWidth*20/24*0.8*0.2862+'px',
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function() {
        this.activeName=this.$route.query.step;
        switch (this.activeName){
          case "first":
            this.titlePic="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-165.png";
            this.showIndex=0;
            break;
          case "second":
            this.titlePic="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-166.png";
            this.showIndex=1;
            break;
          case "third":
            this.titlePic="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-167.png";
            this.showIndex=2;
            break;
          case "fourth":
            this.titlePic="http://zgpic.xingfujijiu.cn/%E5%AE%98%E7%BD%91%E5%9B%BE%E6%A0%87_%20-168.png";
            this.showIndex=3;
            break;
          default:
            break;
        }
      }
    }
  },
  created() {
    PubSub.publish('changeIndex', this.$route);
  },
  mounted() {

    setTimeout(function(){
      //手动触发窗口resize事件
      if(document.createEvent) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("resize", true, true);
        window.dispatchEvent(event);
      } else if(document.createEventObject) {
        window.fireEvent("onresize");
      }
    },1);

    window.addEventListener("resize", () => {
      var deviceWidth=document.body.clientWidth<850?850:document.body.clientWidth;
      this.minFontSize=(deviceWidth/85)+"px";
      var lists=this.$el.querySelectorAll('.el-tabs__nav .el-tabs__item');
      for (var i=0;i<lists.length;i++) {
        var fsize=deviceWidth/75;
        if (fsize<20)fsize=20;
        lists[i].style.fontSize=fsize+"px";
      }
      this.mHeight=document.body.clientWidth*800/1920+30+'px';
      this.height1=document.body.clientWidth*700/1920+'px';
      this.contentH=document.body.clientWidth*20/24*0.8*0.2862+'px';
    });
  },

}
</script>

<style lang="scss">

.selfdiv{
  .el-tabs__active-bar.is-top{
    background:url("http://zgpic.xingfujijiu.cn/bline.png") no-repeat 100%;
    background-position: center;
    height: 13px;
  }
  .el-tabs__nav-wrap::after{
    background-color: #cfcfcf;
    height: 2px;
  }
  .el-tabs__item.is-active{
    color: #ff5e0e;
  }
  .el-tabs__item.is-top:hover{
    color: #ff5e0e;
  }
  .el-tabs__item.is-top{
    height: 50px;
  }
  .el-tabs.el-tabs--top{
    margin-top: 50px;
  }
  .el-tabs__item{
    padding: 0px;
  }
}

.pointer:hover{
  cursor: pointer;
}
</style>